import { Theme } from '@mui/material/styles'

const useStyles = {
  menuItemWithIcon: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftSpaceIcon: (theme: Theme) => ({
    marginLeft: theme.spacing(1),
  }),
}
export default useStyles
